
import { defineComponent } from "vue";
import Report from "./Report.vue";
import LoadingReportFilter from "./LoadingReportFilter.vue";
import router from "@/router";

export default defineComponent({
  components: {
    Report,
    LoadingReportFilter,
  },
  methods: {
    onReport(planId: any, options: any, containerId: any, schemeId: any, showName: any) {
      this.$refs.reportComponent.onReport(
        planId,
        options,
        containerId,
        schemeId,
        showName
      );
    },
    onDownload(planId: any, options: any, containerId: any, schemeId: any, showName: any) {
      this.$refs.reportComponent.onDownload(
        planId,
        options,
        containerId,
        schemeId,
        showName
      );
    },
    onStop() {
      this.$refs.reportComponent.onStop();
    },
  },
  mounted() {
    const routeParams = router.currentRoute.value.params;
    if (routeParams.planId) {
      const model = {
        planId: parseInt(routeParams.planId as string),
        planDescription: routeParams.planDescription,
      };
      this.$refs.reportFilter.setModel(model);
    }
  },
});
